import useSearchParams from "@/hooks/useSearchParams";
import { useQueries, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getBrandCount, getBrandSearch } from "src/api/brand";
import { useBrandStore } from "../BrandProvider";
export const SWIPER_LIMIT = 7;
export const useBrandAllSearch = ()=>{
    const name = useBrandStore((state)=>state.brand.name);
    const searchParams = useSearchParams();
    const keyword = searchParams.get("q");
    // 1.먼저 브랜드에서 운영하는 과목에 대한 정보를 위해 count api 호출
    const { data: subjectCount = []  } = useQuery([
        "brandSubjectCount",
        name,
        keyword
    ], ()=>getBrandCount({
            name: name
        }), {
        enabled: !!name,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        select: (data)=>{
            if (!(data === null || data === void 0 ? void 0 : data.countBySubject)) return [];
            return Object.entries(data.countBySubject).filter((param)=>{
                let [_, count] = param;
                return count > 0;
            }).map((param)=>{
                let [subject] = param;
                return subject;
            });
        }
    });
    // 2. 1번에서 조회한 과목들을 이용하여 각 과목별 상품 조회
    const results = useQueries({
        queries: subjectCount === null || subjectCount === void 0 ? void 0 : subjectCount.map((subject)=>({
                queryKey: [
                    "subjectAll",
                    subject,
                    keyword,
                    name
                ],
                queryFn: ()=>getBrandSearch({
                        name: name,
                        subject: subject,
                        q: keyword,
                        limit: SWIPER_LIMIT
                    }),
                enabled: !!name && !!subjectCount || !!keyword,
                keepPreviousData: true,
                refetchOnWindowFocus: false,
                refetchOnMount: false,
                retry: 1,
                select: (data)=>({
                        subject: subject,
                        count: data.pagination.total,
                        items: data.items.slice(0, SWIPER_LIMIT)
                    })
            }))
    });
    const subjectBundle = useMemo(()=>{
        if (!results || !subjectCount) return null;
        return results.filter((result)=>result.isSuccess).map((result)=>result.data);
    }, [
        results,
        subjectCount
    ]);
    return {
        availableSubjectList: subjectCount,
        subjectBundle
    };
};
export default useBrandAllSearch;
